import { Immutable } from "immer";
import React from "react";
import { BlogTile } from "tsi-common-react/src/components/BlogTile/index";

import { templates } from "@reactivated";

type ITempurLoveBlogTileProps = Immutable<{
    tileImage?: {
        block: {
            url: string;
            title?: string | null;
        };
    } | null;
    tileTitle: string;
    tileBody: string;
    url: string;
    categories: templates.TempurLoveStoryPageDocumentTemplate["categories"];
    loveRootUrl: string;
}>;

export const TempurLoveBlogTile = (
    props: ITempurLoveBlogTileProps,
): React.JSX.Element => {
    return <BlogTile {...props} twitterHandle="stearnsandfoster" />;
};
